import EmployeeLayout from "../components/layout/EmployeeLayout";
import SchedulesPage from "./SchedulesPage";

export default function EmployeeTeamSchedulePage() {
  return (
    <EmployeeLayout pageTitle="Team Schedule">
      <SchedulesPage view="employee" readOnly skipLayout />
    </EmployeeLayout>
  );
}
